export default "__VITE_ASSET__DwbcG1Xf__"